var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPasswordvisible = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5241_1056",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5241_1056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 10.6667C8.83329 10.6667 9.54163 10.375 10.125 9.79166C10.7083 9.20832 11 8.49999 11 7.66666C11 6.83332 10.7083 6.12499 10.125 5.54166C9.54163 4.95832 8.83329 4.66666 7.99996 4.66666C7.16663 4.66666 6.45829 4.95832 5.87496 5.54166C5.29163 6.12499 4.99996 6.83332 4.99996 7.66666C4.99996 8.49999 5.29163 9.20832 5.87496 9.79166C6.45829 10.375 7.16663 10.6667 7.99996 10.6667ZM7.99996 9.46666C7.49996 9.46666 7.07496 9.29166 6.72496 8.94166C6.37496 8.59166 6.19996 8.16666 6.19996 7.66666C6.19996 7.16666 6.37496 6.74166 6.72496 6.39166C7.07496 6.04166 7.49996 5.86666 7.99996 5.86666C8.49996 5.86666 8.92496 6.04166 9.27496 6.39166C9.62496 6.74166 9.79996 7.16666 9.79996 7.66666C9.79996 8.16666 9.62496 8.59166 9.27496 8.94166C8.92496 9.29166 8.49996 9.46666 7.99996 9.46666ZM7.99996 12.6667C6.37774 12.6667 4.89996 12.2139 3.56663 11.3083C2.23329 10.4028 1.26663 9.18888 0.666626 7.66666C1.26663 6.14443 2.23329 4.93055 3.56663 4.02499C4.89996 3.11943 6.37774 2.66666 7.99996 2.66666C9.62218 2.66666 11.1 3.11943 12.4333 4.02499C13.7666 4.93055 14.7333 6.14443 15.3333 7.66666C14.7333 9.18888 13.7666 10.4028 12.4333 11.3083C11.1 12.2139 9.62218 12.6667 7.99996 12.6667ZM7.99996 11.3333C9.25552 11.3333 10.4083 11.0028 11.4583 10.3417C12.5083 9.68055 13.3111 8.78888 13.8666 7.66666C13.3111 6.54443 12.5083 5.65277 11.4583 4.99166C10.4083 4.33055 9.25552 3.99999 7.99996 3.99999C6.7444 3.99999 5.59163 4.33055 4.54163 4.99166C3.49163 5.65277 2.68885 6.54443 2.13329 7.66666C2.68885 8.78888 3.49163 9.68055 4.54163 10.3417C5.59163 11.0028 6.7444 11.3333 7.99996 11.3333Z",
    fill: "#47484C"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPasswordvisible);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/passwordvisible.570ea32386e44d4ded55c41a5400c43a.svg";